import { render } from "./SidebarProfileComp.vue?vue&type=template&id=5c4fbd95&scoped=true&ts=true"
import script from "./SidebarProfileComp.vue?vue&type=script&lang=ts"
export * from "./SidebarProfileComp.vue?vue&type=script&lang=ts"

import "./SidebarProfileComp.vue?vue&type=style&index=0&id=5c4fbd95&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4fbd95"]])

export default __exports__